if (typeof StickyATC !== 'function') {
  class StickyATC extends HTMLElement {
    constructor() {
      super();
      this.init();
    }
    init() {
      const scroll_offset_top = this.getOffset(document.querySelector('product-form')).top;
      const scroll_offset_bottom = this.getOffset(document.querySelector('.newsletter__container')).top;
      const btn = this;
      window.addEventListener('scroll', function () {
        if (window.scrollY > scroll_offset_top && window.scrollY < scroll_offset_bottom) {
          btn.classList.add('revealed');
        } else {
          btn.classList.remove('revealed');
        }
      });
      btn.addEventListener('click', function () {
        const sidebarWidget = document.querySelector('.sidebar-widget');
        if (sidebarWidget) {
          window.scrollTo({
            top: sidebarWidget.offsetTop,
            behavior: 'smooth'
          });
        }
      });
    }
    getOffset(el) {
      var position = el.getBoundingClientRect();
      return {
        left: position.left + window.scrollX,
        top: position.top + window.scrollY
      };
    }
  }
  if (typeof customElements.get('sticky-atc') == 'undefined') {
    customElements.define('sticky-atc', StickyATC);
  }
}